import {gql} from "@apollo/client";

export const GET_JOB_RUN = gql`
	query getJobRun(
		$jobRunId: Int
	) {
		jobRun (
			where: { id: { eq: $jobRunId } }
		) {
			nodes {
				id
				start
				finish
				description
				graphQlQuery
			}
		}
	}
`;
